export default "__VITE_ASSET__p_r9ouOv__"